import React from "react";
import { motion } from "framer-motion";

export const ParticipationSection: React.FC = () => {
  const rules = [
    {
      title: "Ekip Oluşturma",
      detail:
        "Takımlar en az 2, en fazla 4 kişiden oluşmalıdır.",
    },
    {
      title: "Uygunluk",
      detail: "Ön lisans, lisans, yüksek lisans ve doktora düzeyindeki öğrenciler katılabilir.",
    },
    {
      title: "Tek Takım Kuralı",
      detail: "Her katılımcı yalnızca tek bir takımda yarışmaya katılabilir.",
    },
    {
      title: "Özgünlük ve Uygunluk",
      detail:
        "Projelerin özgün olması, daha önce yayınlanmamış ve başka bir yarışmaya katılmamış olması beklenir.",
    },
  ];
  const provided = [
    "Katılım Ücretsizdir",
    "Jüriye 5 dk Sunum",
    "3 dk Soru-Cevap",
    "Saha Uyumlu Değerlendirme",
    "Kurumsal Networking",
    "Final Günü Yüz Yüze Sunum",
  ];

  return (
    <section id="rules" className="section-shell bg-[var(--bg-secondary)] relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-9">
          <h2 className="text-4xl sm:text-5xl font-black text-[var(--text-primary)] mb-4">
            Katılım Şartları
          </h2>
          <div className="w-24 h-1 mx-auto rounded-full mb-6 bg-[#73E03A]" />
          <p className="text-[var(--text-secondary)] text-sm sm:text-base max-w-2xl mx-auto">
            Her seviyeden katılımcıya açık, şeffaf ve adil bir yarışma yapısı.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {rules.map((item, idx) => (
            <motion.article
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -6, scale: 1.02 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08, type: "spring", stiffness: 220, damping: 18 }}
              className="kapsul-card p-4 sm:p-5"
              style={{ borderColor: "rgba(47,111,30,0.55)" }}
            >
              <h3 className="text-base sm:text-lg font-bold text-[var(--text-primary)] dark:text-white leading-tight">{item.title}</h3>
              <p className="mt-2 text-sm text-[var(--text-secondary)] leading-relaxed">{item.detail}</p>
            </motion.article>
          ))}
        </div>

        <div
          className="mt-6 kapsul-card p-5"
          style={{
            borderColor: "rgba(47,111,30,0.55)",
            background: "linear-gradient(160deg, rgba(242,252,235,0.96), rgba(233,247,223,0.94))",
          }}
        >
          <h3 className="text-lg font-bold text-[var(--text-primary)] mb-3 flex items-center gap-2">
            Sağlanan İmkanlar
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {provided.map((item) => (
              <span
                key={item}
                className="kapsul-badge kapsul-hover-lift px-3 py-2 text-xs sm:text-sm text-center border font-medium"
                style={{
                  borderColor: "rgba(47,111,30,0.55)",
                  backgroundColor: "rgba(255,255,255,0.46)",
                  color: "#245314",
                }}
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
